
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import szlovak from "../../assets/szlovak.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarSzlovak({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar szlovák fordító</title>
                <meta name='description' content="Ingyenes magyar szlovák fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar szlovák fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-szlovak-fordito" />
            </Helmet>
            <h1>Magyar szlovák fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és szlovák nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={szlovak} alt="szlovák zászló"></img>
                </div>


                <p>Íme néhány hasonlóság és különbség a két nyelv között:</p>

                <h3>Hasonlóságok</h3>
                <ul>
                    <li><b>Ábécé</b>: Mindkét nyelv latin betűs ábécét használ, bár néhány speciális karakter és diakritikus jel eltérő lehet.</li>

                    <li><b>Szókincs</b>: Néhány szóban megtalálhatóak hasonlóságok a szókincsben. Ez azonban általában kölcsönhatásokra vagy azonos eredetre vezethető vissza.</li>

                    <li><b>Nyelvtan</b>: Néhány nyelvtani jelenségben is hasonlóságokat lehet felfedezni. Például mindkét nyelvben vannak névelők, ragok és igekötők.</li>
                </ul>


                <h3>Különbségek</h3>
                <ul>
                    <li><b>Hangrendszer</b>: A magyar és a szlovák nyelv hangrendszere között jelentős különbségek vannak. A magyarban például vannak hangok, amelyek a szlovákban nem léteznek, és fordítva.</li>

                    <li><b>Nyelvtani szerkezet</b>: A két nyelv között jelentős különbségek vannak a nyelvtani szerkezetben. A magyar nyelv agglutináló jellegű, míg a szlovák nyelv flektáló jellegű.</li>

                    <li><b>Szórend</b>: A magyar és a szlovák nyelv szórendje is eltérő. A magyar nyelvben a szabad szórend jellemző, míg a szlovák nyelvben általában a SVO (alany-ige-állítmány) szórend a gyakori.</li>

                    <li><b>Szókincs</b>: A két nyelv között a szókincsben is nagy különbségek vannak. Míg néhány alapvető szó megegyezhet, a kifejezések és a szakzsargon nagyon eltérő lehet.</li>
                </ul>

                <div className="sectionbottom">
                    <Link to="/szlovak-magyar-fordito">Szlovák magyar fordító</Link>
                    <img src={szlovak} alt="szlovák zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarSzlovak;